import { tv, type VariantProps } from 'tailwind-variants'

const styles = tv({
	slots: {
		base: 'flex items-center gap-4',
		name: 'font-bold text-gray-700 text-base',
		figure: 'w-6 h-6',
		image: 'w-full h-full object-cover rounded-full',
	},
})

interface ProfileProps extends VariantProps<typeof styles> {
	className?: string
	nameData: string
}

const { base, name } = styles()

export const Profile = ({ className, nameData, ...rest }: ProfileProps) => (
	<div {...rest} className={`${base()} ${className}`}>
		<span className={name()}>{nameData}</span>
	</div>
)
